import * as React from "react";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button, Calendar, Icon } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

interface FilterDateProps {
  title: string;
  date: Date | undefined;
  onChangeDate: (newDate: Date | undefined) => void;
  disabled?: boolean;
  shouldDisabledFutureDates?: boolean;
}
export default function FilterDate({
  title,
  date,
  onChangeDate,
  disabled = false,
  shouldDisabledFutureDates,
}: FilterDateProps) {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="w-full flex flex-col gap-3">
      <label
        htmlFor="date"
        className={cn(
          "px-1 font-semibold font-geist text-sm leading-2xl text-body-loud",
          disabled && "text-on-disabled",
        )}
      >
        {title}
      </label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="ghost"
            id="date"
            aria-label="date"
            className="w-full justify-between bg-neutral-object-accent-silent border border-neutral"
            disabled={disabled}
          >
            <span
              className={cn(
                "font-normal font-geist text-base leading-3xl text-body-quiet",
                disabled && "text-on-disabled",
                date && "text-body-loud",
              )}
            >
              {date ? date.toLocaleDateString() : "Elegir Fecha..."}
            </span>
            {date && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onChangeDate(undefined);
                }}
                className={cn(
                  "cursor-pointer hover:bg-neutral-object rounded-full border-[0.5px] border-neutral px-1.5 w-6 h-6 text-xs font-normal leading-xl text-body-quiet flex items-center justify-center",
                  disabled && "text-on-disabled border-on-disabled",
                )}
                aria-label="Borrar fecha"
              >
                <Icon
                  type="far"
                  name="xmark"
                  className="text-xs font-normal leading-xl text-body-quiet"
                />
              </button>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto overflow-hidden p-0 bg-neutral-object"
          align="start"
        >
          <Calendar
            mode="single"
            selected={date}
            captionLayout="dropdown"
            className="bg-transparent"
            disabled={
              shouldDisabledFutureDates ? { after: new Date() } : undefined
            }
            onSelect={(date) => {
              onChangeDate(date);
              setOpen(false);
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
